var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2368 6.33417C15.2899 6.33417 16.3947 7.0922 16.785 8.93423L17.4258 14.0964C17.8971 17.4621 16.0043 18.8342 13.4634 18.8342H6.55515C4.0069 18.8342 2.05519 17.8866 2.58547 14.0964L3.23358 8.93423C3.565 7.03914 4.70656 6.33417 5.77447 6.33417H14.2368ZM7.57888 9.10858C7.17212 9.10858 6.84239 9.44796 6.84239 9.86661C6.84239 10.2853 7.17212 10.6246 7.57888 10.6246C7.98563 10.6246 8.31537 10.2853 8.31537 9.86661L8.30963 9.77153C8.26418 9.39776 7.95434 9.10858 7.57888 9.10858ZM12.4029 9.10858C11.9961 9.10858 11.6664 9.44796 11.6664 9.86661C11.6664 10.2853 11.9961 10.6246 12.4029 10.6246C12.8096 10.6246 13.1394 10.2853 13.1394 9.86661C13.1394 9.44796 12.8096 9.10858 12.4029 9.10858Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.1416 6.14602C14.1443 6.21066 14.1318 6.27503 14.1053 6.33409H12.9078C12.8846 6.27404 12.8723 6.21036 12.8715 6.14602C12.8715 4.54811 11.5716 3.25274 9.9682 3.25274C8.36478 3.25274 7.06494 4.54811 7.06494 6.14602C7.07593 6.20823 7.07593 6.27188 7.06494 6.33409H5.83832C5.82733 6.27188 5.82733 6.20823 5.83832 6.14602C5.93151 3.92234 7.76757 2.16742 10.0009 2.16742C12.2342 2.16742 14.0702 3.92234 14.1634 6.14602H14.1416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.887664197b7ab26e05a2ca1692243679.svg";
export { ForwardRef as ReactComponent };